<mat-card>
  <mat-card-content>
    <div id="top">
      <div class="title-section">
        <h1><b>Organization Details</b></h1>
        <div *ngIf="isSuperAdmin$ | async" class="export-audit-container">
          @let isExporting = isExportingAudit$ | async;
          <button
            mat-raised-button
            color="primary"
            [disabled]="isExporting"
            (click)="onExportOrgAudit()"
          >
            <mat-icon>download</mat-icon>
            {{ isExporting ? 'Exporting...' : 'Export Org Audit' }}
          </button>
        </div>
      </div>
      <div class="button-section" *ngIf="isSuperAdmin$ | async">
        <button mat-fab extended (click)="addNewOrganization()" class="warn" id="addOrganization">
          ADD NEW ORGANIZATION
        </button>
        <p class="context-note">Or continue editing the current organization below:</p>
      </div>
    </div>
    
    <div *ngIf="isSuperAdmin$ | async" class="test-org-toggle">
      <mat-checkbox
        color="primary"
        [checked]="(isTestOrganization$ | async) === 1"
        (change)="onTestOrgToggle($event.checked)">
        Test Organization
      </mat-checkbox>
    </div>

    <form [formGroup]="createOrganizationForm" [connectForm]="form$ | async">
      <div id="all-inputs" class="input-group">
        <div class="form-group two-unit">
          <mat-form-field appearance="outline">
            <mat-label for="name">Name</mat-label>
            <input matInput formControlName="name" name="name" id="name">
            @if (createOrganizationForm.get('name')?.invalid && (createOrganizationForm.get('name')?.dirty || createOrganizationForm.get('name')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('name')?.errors?.['required']) {
                  Name is required.
                }
                @if (createOrganizationForm.get('name')?.errors?.['maxlength']) {
                  Name must be no more than 256 characters long.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-group one-unit">
          <mat-form-field appearance="outline">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type" panelClass="searchable-panel">
              <mat-option disabled>
                <ngx-mat-select-search
                  formControlName="typeSearch"
                  placeholderLabel="Search..."
                  noEntriesFoundLabel="No Types Found">
                </ngx-mat-select-search>
              </mat-option>
              @for (type of (organizationTypesDropdown$ | async); track type.id) {
                <mat-option [value]="type.id">{{type.name}}</mat-option>
              }
            </mat-select>
            @if (createOrganizationForm.get('type')?.invalid && (createOrganizationForm.get('type')?.dirty || createOrganizationForm.get('type')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('type')?.errors?.['required']) {
                 Type is required.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-group one-unit">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Organization ID</mat-label>
            <input matInput formControlName="organizationID" readonly="true">
          </mat-form-field>
        </div>

        <div class="form-group one-unit" id="legacyOrganizationID">
          <mat-form-field appearance="outline">
            <mat-label>Legacy ID</mat-label>
            <input matInput formControlName="legacyOrganizationID" type="text">
              @if (createOrganizationForm.get('legacyOrganizationID')?.invalid && (createOrganizationForm.get('legacyOrganizationID')?.dirty || createOrganizationForm.get('legacyOrganizationID')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('legacyOrganizationID')?.errors?.['required']) {
                 Legacy ID is required.
                }
                @if (createOrganizationForm.get('legacyOrganizationID')?.errors?.['maxlength']) {
                 Legacy ID must be no more than 24 characters.
                }
              </mat-error> 
            }
          </mat-form-field>
        </div>

        <div class="form-group one-unit">
          <mat-form-field appearance="outline">
            <mat-label>CRM ID</mat-label>
            <input matInput formControlName="crmID"  type="text">
              @if (createOrganizationForm.get('crmID')?.invalid && (createOrganizationForm.get('crmID')?.dirty || createOrganizationForm.get('crmID')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('crmID')?.errors?.['required']) {
                 CRM ID is required.
                }
                @if (createOrganizationForm.get('crmID')?.errors?.['maxlength']) {
                 CRM ID must be no more than 24 characters.
                }
              </mat-error> 
            }
          </mat-form-field>
        </div>

        <div id="break"></div>

        <div class="form-group two-unit">
          <mat-form-field appearance="outline">
            <mat-label>Address</mat-label>
            <input matInput formControlName="address">
            @if (createOrganizationForm.get('address')?.invalid && (createOrganizationForm.get('address')?.dirty || createOrganizationForm.get('address')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('address')?.errors?.['required']) {
                  Address is required.
                }
                @if (createOrganizationForm.get('address')?.errors?.['maxlength']) {
                  Address must be no more than 50 characters long.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-group one-unit">
          <mat-form-field appearance="outline">
            <mat-label>Building/Suite/Floor</mat-label>
            <input matInput formControlName="addressB">
            @if (createOrganizationForm.get('addressB')?.invalid && (createOrganizationForm.get('addressB')?.dirty || createOrganizationForm.get('addressB')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('addressB')?.errors?.['maxlength']) {
                  Address must be no more than 50 characters long.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-group one-unit">
          <mat-form-field appearance="outline">
            <mat-label>Zip Code</mat-label>
            <input matInput formControlName="zipCode">
            @if (createOrganizationForm.get('zipCode')?.invalid && (createOrganizationForm.get('zipCode')?.dirty || createOrganizationForm.get('zipCode')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('zipCode')?.errors?.['required']) {
                  Zip Code is required.
                }
                @if (createOrganizationForm.get('zipCode')?.errors?.['maxlength']) {
                  Zip Code must be no more than 15 characters long.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-group one-unit">
          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input matInput formControlName="city">
            @if (createOrganizationForm.get('city')?.invalid && (createOrganizationForm.get('city')?.dirty || createOrganizationForm.get('city')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('city')?.errors?.['required']) {
                  City is required.
                }
                @if (createOrganizationForm.get('city')?.errors?.['maxlength']) {
                  City must be no more than 35 characters long.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-group one-unit">
          <mat-form-field appearance="outline">
            <mat-label>State</mat-label>
            <mat-select formControlName="state" panelClass="searchable-panel">
              <mat-option disabled>
                <ngx-mat-select-search
                  formControlName="stateSearch"
                  placeholderLabel="Search..."
                  noEntriesFoundLabel="No States Found">
                </ngx-mat-select-search>
              </mat-option>
              @for (state of (statesDropdown$ | async); track state.id) {
                <mat-option [value]="state.id">{{state.name}}</mat-option>
              }
            </mat-select>
            @if (createOrganizationForm.get('state')?.invalid && (createOrganizationForm.get('state')?.dirty || createOrganizationForm.get('state')?.touched)) {
              <mat-error>
                @if (createOrganizationForm.get('state')?.errors?.['required']) {
                  State is required.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>